import { EmailType } from '@business/constants/emailtype';
import { R } from '@core/utils/r';
import { ContactEmailResponse, ContactPhoneResponse } from './../../entities/contact/ContactResponse';
import { ContactStatusResponse } from '@business/entities/contact_status';
import { SettingsConfig } from '@core/utils/config';
import { FieldType } from '@business/entities/settingFields';

// export function getStatusTitle(status: ContactStatus) {
//   switch (status) {
//     case ContactStatus.active:
//       return 'Active';
//     case ContactStatus.inactive:
//       return 'Inactive';
//     case ContactStatus.dontmessage:
//       return 'Do Not Message';
//     case ContactStatus.dns:
//       return 'Do Not Sell';
//   }
// }

export function getStatuses() {
  return SettingsConfig.current()?.contactStatuses || [];
}

// export function isBannerStatus(status: ContactStatusResponse) {
//   if (status.name === 'Do Not Message' || status.name === 'Do Not Sell' || status.name === 'Do Not Bill') {
//     return true;
//   }
//   return false;
// }

export function getPhoneString(phone: ContactPhoneResponse) {
  const basePhone = `${phone.countryCode}${phone.value}`;
  const ext = !R.isEmpty(phone.ext) ? ` Ext: ${phone.ext}` : '';
  return `${basePhone}${ext} (${R.upperFirst(phone.type)})`;
}

export function getEmailString(email: ContactEmailResponse) {
  return `${email.value} (${R.upperFirst(email.type)})`;
}

export function getTypeColor(type: EmailType) {
  switch (type) {
    case EmailType.home:
      return 'success';
    case EmailType.work:
      return 'primary';
    case EmailType.other:
      return undefined;
    case EmailType.mobile:
      return 'dark';
  }
}

export function getActivityIcon(type: string) {
  switch (type) {
    case 'note':
      return 'bx bx-notepad';
    case 'interviewInPerson':
      return 'bx bx-user';
    case 'other':
      return 'bx bx-smile';
    case 'metting':
      return 'bx bx-calendar';
    case 'interview':
      return 'bx bx-timer';
    case 'noMessage':
      return 'bx bx-message-alt';
    case 'leftMessage':
      return 'bx bx-message-alt-dots';
    case 'email':
      return 'bx bx-envelope';
    default:
      return 'bx bx-plus';
  }
}

export function getFilterCustomFields() {
  const settings = SettingsConfig.current();
  if (!settings) return [];
  return R.pipe(
    settings.customFields,
    R.ops.filter(f => f.filter),
    R.ops.filter(f => f.for === 'people'),
    R.ops.filter(f => [FieldType.dropdown, FieldType.multiOptions, FieldType.singleOption].includes(f.type)),
  );
  //   return settings.customFields.filter(f => f.for === 'organizations' && f.type === FieldType.dropdown);
}
